export default "__VITE_ASSET__BZfXKsYM__"